export default {
  LOADING: 'LOADING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  NOT_STARTED: 'NOT_STARTED'
};



// WEBPACK FOOTER //
// ./src/constants/loadingStates.js